import React from 'react';
import FilterRow from './FilterRow';
import { getCategories } from './helpers';
import './FiltersSet.scss';

const Filters = ({
  addVisualization,
  filters,
  removeVisualization,
  view = 'timeserie',
}) => {
  if (!filters.length) {
    return null;
  }
  const itemCount = Object.keys(filters[0]).length;
  const colSpan = itemCount + Number(Boolean(itemCount));

  return (
    <div className="table-responsive">
      <h2 className="h2TitleFilter">Parameters</h2>
      <table className="table borderless table-center">
        <thead>
          <tr>
            {filters.length > 1 && <th>Action</th>}
            {getCategories(view).map(({ label }) => (
              <th key={label}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filters.map((filter, index) => (
            <FilterRow
              key={`${index}${JSON.stringify(filter)}`}
              row={filter}
              index={index}
              filters={filters}
              removeVisualization={removeVisualization}
              view={view}
            />
          ))}
          {addVisualization && (
            <tr>
              <td colSpan={colSpan}>
                <button
                  className="filters-button"
                  onClick={addVisualization}
                  type="button"
                >
                  + Add filter row
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Filters;
